import Vue from 'vue'
import Swal from 'sweetalert2'

const Sweetalert = {
  confirm (text, title = '', allowOutsideClick = true) {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title,
        html: text,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        cancelButtonColor: '#f55246',
        allowOutsideClick
      }).then(result => {
        if (result.value) {
          resolve(result.value)
        } else {
          reject(null)
        }
      })
    })
  },

  info (title, text = '', allowOutsideClick = true, btnOk = true) {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title,
        html: text,
        icon: 'info',
        showConfirmButton: btnOk,
        allowOutsideClick
      })
    })
  },

  success (title, text = '', allowOutsideClick = true, btnOk = true) {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title,
        html: text,
        icon: 'success',
        showConfirmButton: btnOk,
        allowOutsideClick
      })
    })
  },

  error (title, text = '', allowOutsideClick = true, btnOk = true) {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title,
        html: text,
        icon: 'error',
        showConfirmButton: btnOk,
        allowOutsideClick
      })
    })
  },

  warning (title, text = '', allowOutsideClick = true, btnOk = true) {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title,
        html: text,
        icon: 'warning',
        showConfirmButton: btnOk,
        allowOutsideClick
      })
    })
  },

  async inputText (
    title,
    validator = true,
    placeholder = '',
    inputValue = '',
    maxlength = 60
  ) {
    const { value: inputedText } = await Swal.fire({
      title,
      input: 'text',
      inputValue: inputValue,
      inputPlaceholder: placeholder,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      inputAttributes: {
        maxlength,
        autocapitalize: 'off',
        autocorrect: 'off'
      },
      inputValidator: value => {
        if (!value && validator) {
          return 'Por favor, preencha este campo'
        }
      },
      allowOutsideClick: false
    })

    return inputedText
  }
}

Vue.prototype.$swal = Sweetalert

export default Sweetalert
